module.exports = __webpack_public_path__ + "img/5.3e83be81.jpg";